import { render, staticRenderFns } from "./new_story_button.vue?vue&type=template&id=2c43aef1&scoped=true&lang=pug"
import script from "./new_story_button.vue?vue&type=script&lang=js"
export * from "./new_story_button.vue?vue&type=script&lang=js"
import style0 from "./new_story_button.vue?vue&type=style&index=0&id=2c43aef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c43aef1",
  null
  
)

export default component.exports